var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleCarplayAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / apple_carplay_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-9.30555424e-14%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD319",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18D722",
    offset: "22%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86FC6F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-apple_carplay_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CarPlay"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Apple---Fill",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8920612,72.961165 C29.382285,72.961165 16.7647059,60.6141216 16.7647059,45.4368932 C16.7647059,30.2596648 29.382285,17.9126214 44.8920612,17.9126214 C53.8693854,17.9126214 62.3811394,22.1612849 67.6641019,29.2776885 C68.1473536,29.96484 67.9827208,30.9037013 67.293017,31.3938962 C66.6033131,31.8840912 65.6400077,31.7468924 65.1217116,31.084648 C60.4288907,24.761829 52.8665222,20.9866073 44.8920612,20.9866073 C31.1149608,20.9866073 19.906675,31.9545743 19.906675,45.4362775 C19.906675,58.9173651 31.1149608,69.8859478 44.8920612,69.8859478 C52.8501643,69.8859478 60.4030956,66.1242706 65.0984331,59.8217683 C65.6180413,59.1616901 66.5804376,59.0268323 67.2684678,59.5176876 C67.9564979,60.008543 68.119682,60.9464138 67.6364193,61.6324218 C62.3534569,68.7266617 53.8505109,72.961165 44.8920612,72.961165 Z M39.7726774,33.6556405 C39.5310843,33.4814089 39.2542588,33.3274942 39.0271361,33.3274942 C38.4508284,33.3278338 37.9837253,33.7849216 37.9833782,34.3488726 L37.9833782,56.156134 C37.9843541,56.5264296 38.1899434,56.8672421 38.5207768,57.0469983 C38.8516101,57.2267544 39.2559283,57.2173311 39.5776413,57.0223663 C39.7733065,56.9016972 58.6509162,46.3671541 58.8339985,46.2107767 C59.0542006,46.0236163 59.1932425,45.7478011 59.1932425,45.4399715 C59.1932425,45.1752381 59.0906912,44.9345154 58.9220793,44.7528959 C58.7308181,44.5478814 40.0878809,33.8828187 39.7726774,33.6556405 Z",
    id: "CarPlay---Fill",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleCarplayAppTile);
export default __webpack_public_path__ + "static/media/apple_carplay_app_tile.96a58ba50d079e55da15bd01fb62a992.svg";
export { ForwardRef as ReactComponent };